export const tomProgramData = { 
    title: "Program (nejen) pro turistické oddíly mládeže",
    introduction: "Pro účastníky z řad turistických oddílů mládeže jsme nad rámec srazového programu připravili neturistické aktivity plné poznání a zábavy.",
    agendaItems: [
      {
        subtitle: "discgolf u jezera na Štěrkovně",
        descriptions: [
          "oproti záloze zapůjčíme vše pro discgolf v Kulturním domě nebo u jezera",
        ],
        src: "/images/program/tomici-discgolf.jpg"
      },
      {
        subtitle: "poznání města Hlučín na koloběžkách",
        descriptions: [
          "oproti záloze zapůjčíme koloběžky v Kulturním domě nebo u jezera",
        ],
      },
      {
        subtitle: "distanční hra Sacharin",
        descriptions: [
          "zahrajte si na detektivy a vydejte se po stopách utečence Sacharina"
        ],
        src: "/images/program/tomici-sacharin.jpg"
      },
      {
        subtitle: "distanční městská hra - QR",
        descriptions: [
          "využijte své telefony skutečně na plno a prostřednictvím QR kódů se dozvíte o historii a zajímavostech města Hlučín",
        ],
      },
      {
        subtitle: "bojová městská hra Vyzvědač",
        descriptions: [
          "hraje se pod rouškou tmy s čelovkami",
        ],
      },
      {
        subtitle: "lezecká stěna",
        descriptions: [
          "v areálu jezera se nachází venkovní lezecká stěna, v případě dobrého počasí zapůjčíme lezecké vybavení a v určených časech zajistíme i bezpečné jištění",
        ],
      },
    ]
  };